/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import SearchControl from 'app/components/common/SearchControl.jsx';
import * as _ from 'underscore';

class SocialModalHeader extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		let Icon = null,
			iconElement = null,
			buttonClass = "btn-primary",
			placeholder = 'Search connected socials',
			connectButton = null,
			constants = this.props.app.config.constants,
			showNewTwitter = true,
			twitterCount = 0;

		if (this.props.serviceId) {
            Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.serviceId)];
			iconElement = <Icon small={true} bare={true} white={true}/>;
			buttonClass += " " + ConstantMixin.getIconIndexByCode(this.props.serviceId);
			placeholder = 'Search connected ' + ConstantMixin.getPostServiceNameByCode(this.props.serviceId) + ' socials';
		}

		if (this.props.twitterMaxedOut) {
			showNewTwitter = false;
		} else {
			for (let i = 0; i < this.props.selectedSocials.length; ++i) {
				let social = _.find(this.props.socials.list, function(social) {
					return this.props.selectedSocials[i] == social.id;
				}.bind(this));
				if (social && social.psID == constants.POST_SVC_TWITTER) {
					++twitterCount;
				}
			}
			if (twitterCount >= constants.MAX_TWITTER_OUTPUTS) {
				showNewTwitter = false;
			}
		}

		if (this.props.serviceId === constants.POST_SVC_MASTODON) {
			connectButton = (
				<button className={buttonClass} onClick={() => {
						this.props.switchView('providehandle')
					}} data-serviceid={this.props.serviceId} data-direct={true}>
					{iconElement} <span>Connect New</span>
				</button>
			);
		} else if (this.props.serviceId !== constants.POST_SVC_TWITTER || showNewTwitter) {
			connectButton = (
				<button className={buttonClass} onClick={ConnectMixin.connectService.bind(this)} data-serviceid={this.props.serviceId} data-direct={true}>
					{iconElement} <span>Connect New</span>
				</button>
			);
		}

		return (
			<div className="dlvr-modal-controls social-modal">
				<div className="modal-controls-wrapper">
					<div className="service-connector">
						{connectButton}
					</div>
					<div className="search-control">
						<SearchControl
							{...this.props}
							changeHandler={this.props.searchHandler}
							focusHandler={this.props.focusHandler}
							reset={this.props.resetSearch}
							placeholder={placeholder}
							extraClasses="social-modal-search"
							wrapperClass="social-modal"
							defaultFocus={false}/>
					</div>
				</div>
			</div>
		);
	}
};

SocialModalHeader.propTypes = {
	serviceId: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	connectAction: PropTypes.func,
	searchHandler: PropTypes.func,
	focusHandler: PropTypes.func,
	resetSearch: PropTypes.bool
};

SocialModalHeader.defaultProps = {
	serviceId: 0,
	connectAction: null,
	searchHandler: null,
	focusHandler: null,
	resetSearch: null
};

export default SubscriptionModule(SocialModalHeader);
